<template>
  <header class="site-header mo-left header">
    <!-- top bar -->
    <div class="top-bar bg-dark">
      <div class="container">
        <div class="row d-flex justify-content-between">
          <div class="dlab-topbar-left">
            <ul>
              <li><a class="site-button-link" href="#">Tout</a></li>
              <li><a class="site-button-link" href="#">Hotels</a></li>
              <li><a class="site-button-link" href="#">Restaurants</a></li>
              <li><a class="site-button-link" href="#">Tourisme</a></li>
            </ul>
          </div>
          <div class="dlab-topbar-right top-login">
            <ul>
              <li><router-link to="connection" class="site-button-link">Connection</router-link></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- top bar END-->
    <!-- main header -->
    <div class="sticky-header navbar-expand-lg main-bar-wraper">
      <div class="main-bar clearfix onepage">
        <div class="container clearfix">
          <!-- website logo -->
          <div class="logo-header mostion">
            <a href="#"><img src="../../assets/img/logo.png" alt=""></a>
          </div>
          <!-- nav toggle button -->
          <button class="navbar-toggler collapsed navicon justify-content-end" type="button" data-toggle="collapse" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
            <span></span>
            <span></span>
            <span></span>
          </button>
          <!-- extra nav -->
          <div class="extra-nav">
            <div class="extra-cell">
              <button id="quik-search-btn" type="button" class="site-button-link"><i class="fa fa-search"></i></button>
            </div>
          </div>
          <!-- Quik search -->
          <div class="dlab-quik-search bg-primary search-style-1">
            <form action="#">
              <input name="search" value="" type="text" class="form-control" placeholder="Type to search">
              <span id="quik-search-remove"><i class="ti-close"></i></span>
            </form>
          </div>
          <!-- main nav -->
          <div class="header-nav navbar-collapse collapse navbar myNavbar justify-content-end" id="navbarNavDropdown">
            <ul class="nav navbar-nav">
              <li><router-link exact-active-class="active-router" to="/">Accueil</router-link></li>
              <li><router-link exact-active-class="active-router" to="offres">Offres</router-link></li>
              <li><router-link exact-active-class="active-router" to="entreprises">Entreprises</router-link></li>
              <li><router-link exact-active-class="active-router" to="blog">Blog</router-link></li>
              <li><router-link exact-active-class="active-router" to="apropos">A propos</router-link></li>
              <li><router-link exact-active-class="active-router" to="contact">Contact</router-link></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- main header END -->
  </header>
</template>

<script>
import {mapGetters, mapMutations, mapActions} from 'vuex'
import router from "../../router";

export default {
  name: "Header",
  props: {},
  components: {},
  data(){
    return{}
  },
  methods: {
    ...mapMutations([]),
    ...mapActions([]),
  },
  computed: {
    ...mapGetters([]),
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {}
}
</script>

<style lang="scss" scoped>
header{}
.active-router{
  color: #00f !important;
}
@media (min-width: 576px) {
  header{}
}

@media (min-width: 768px) {
  header{}
}

@media (min-width: 992px) {
  header{}
}

@media (min-width: 1200px) {
  header{}
}

</style>



// WEBPACK FOOTER //
// src/components/shared/Header.vue